module.exports = __webpack_public_path__ + "img/expired_img.fa62c8a9.png";